import { IPageableResponse } from "@common/pagination/IPageable";
import { IAlert } from "../interface/IAlert";

export interface IAlertContentResponse {
    message: string;
    navLink: string;
    navLinkLabel: string;
}

export interface IAlertResponse {
    content: IAlertContentResponse;
    createdAt: string;
    iconName: string;
    id: number;
}

export interface IAlertListResponse {
    webNotifications: IPageableResponse<IAlertResponse>;
}

export const getResponseToState = (response: IAlertListResponse): IPageableResponse<IAlert> => ({
    content: response.webNotifications.content.map((alert) => ({
        navLink: alert.content.navLink,
        navLinkLabel: alert.content.navLinkLabel,
        message: alert.content.message,
        createdAt: alert.createdAt,
        iconName: alert.iconName,
        id: alert.id,
    })),
    totalPages: response.webNotifications.totalPages,
});
